import { getDomain } from "./helpers.js";
import axios from "axios";
import store from "../store";

export const ATTENDANCE_SCAN_TYPE = "AttendanceScanType";

export const DEFAULT_ATTENDANCE_SCAN_TYPES = [
    "ABSENT",
    "Absent-Day",
    "Abset-Brekfast",
    "Absent Breakfast Permission",
    "Late",
];

function authHeaders() {
    return {
        Authorization: store.state.authentication.token,
    };
}

export async function loadOptions(type) {
    const url =
        getDomain() + `/odata/smlookup?$filter=contains(type, '${type}')`;

    const response = await axios.get(url, {
        headers: authHeaders(),
    });

    return response.data.value;
}

export async function loadLookupValues(type) {
    const options = await loadOptions(type);

    return (options || [])
        .filter((option) => option.type === type)
        .sort((a, b) => {
            const orderA = a.sortOrder == null ? 9999 : a.sortOrder;
            const orderB = b.sortOrder == null ? 9999 : b.sortOrder;

            if (orderA !== orderB) {
                return orderA - orderB;
            }

            return (a.value || "").localeCompare(b.value || "");
        });
}

export async function ensureLookupValues(type, values) {
    const existing = await loadLookupValues(type);

    if (existing.length) {
        return existing;
    }

    await axios.post(
        getDomain() + "/api/smLookup/save",
        values.map((value, index) => ({
            id: 0,
            type: type,
            value: value,
            sortOrder: index + 1,
        })),
        {
            headers: authHeaders(),
        },
    );

    return loadLookupValues(type);
}

export default { loadOptions };
